import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, Transition as _Transition, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between min-w-0 gap-3 px-3 py-3 sm:px-4 lg:px-6 bg-white border-b border-slate-200" }
const _hoisted_2 = { class: "flex min-w-0 items-center" }
const _hoisted_3 = { class: "flex min-w-0 items-center gap-1.5 sm:mx-2 lg:mx-0" }
const _hoisted_4 = { class: "flex min-w-0 flex-col" }
const _hoisted_5 = { class: "truncate text-xl font-bold leading-none text-slate-900 sm:text-2xl" }
const _hoisted_6 = { class: "flex shrink-0 items-center" }
const _hoisted_7 = {
  key: 0,
  class: "hidden items-center sm:flex"
}
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = {
  key: 0,
  class: "absolute -right-1 -top-1 inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-red-500 px-1.5 py-0.5 text-[10px] font-bold leading-none text-white ring-2 ring-white"
}
const _hoisted_10 = { class: "absolute right-0 z-20 mt-3 w-[28rem] max-w-[calc(100vw-1.5rem)] overflow-hidden rounded-lg border border-slate-200 bg-white shadow-xl" }
const _hoisted_11 = { class: "flex items-start justify-between gap-3 border-b border-slate-100 px-4 py-3.5" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "grid grid-cols-2 divide-x divide-slate-100 border-b border-slate-100 bg-slate-50" }
const _hoisted_14 = { class: "mt-1 text-lg font-bold text-slate-950" }
const _hoisted_15 = { class: "mt-1 text-lg font-bold text-slate-950" }
const _hoisted_16 = {
  key: 0,
  class: "border-b border-red-100 bg-red-50 px-4 py-2.5 text-xs font-medium text-red-700"
}
const _hoisted_17 = {
  key: 1,
  class: "space-y-3 px-4 py-4"
}
const _hoisted_18 = {
  key: 2,
  class: "px-4 py-8 text-center"
}
const _hoisted_19 = {
  key: 3,
  class: "max-h-[22rem] overflow-y-auto"
}
const _hoisted_20 = {
  key: 0,
  class: "h-4 w-4",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_21 = {
  key: 1,
  class: "h-4 w-4",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_22 = { class: "min-w-0 flex-1" }
const _hoisted_23 = { class: "flex items-start justify-between gap-2" }
const _hoisted_24 = { class: "flex min-w-0 items-center gap-2" }
const _hoisted_25 = {
  key: 0,
  class: "h-2 w-2 shrink-0 rounded-full bg-red-500"
}
const _hoisted_26 = { class: "truncate text-sm font-bold text-slate-950" }
const _hoisted_27 = { class: "shrink-0 text-[11px] font-medium text-slate-400" }
const _hoisted_28 = { class: "mt-0.5 truncate text-sm font-medium text-slate-700" }
const _hoisted_29 = { class: "mt-1 line-clamp-2 text-xs leading-relaxed text-slate-500" }
const _hoisted_30 = { class: "mt-2 flex flex-wrap items-center gap-2" }
const _hoisted_31 = {
  key: 0,
  class: "text-xs font-bold text-slate-900"
}
const _hoisted_32 = { class: "grid grid-cols-2 divide-x divide-slate-100 border-t border-slate-100 bg-white" }
const _hoisted_33 = { class: "relative" }
const _hoisted_34 = { class: "flex items-center gap-2" }
const _hoisted_35 = { class: "hidden max-w-[220px] truncate text-sm font-semibold text-slate-700 md:inline" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "absolute right-0 z-20 w-72 overflow-hidden mt-2 bg-white rounded-lg border border-slate-200 shadow-xl" }
const _hoisted_38 = { class: "border-b border-slate-100 bg-slate-50 px-4 py-3" }
const _hoisted_39 = { class: "flex items-center gap-3" }
const _hoisted_40 = { class: "block h-8 w-8 shrink-0 overflow-hidden rounded-full shadow" }
const _hoisted_41 = ["src"]
const _hoisted_42 = { class: "min-w-0 flex-1" }
const _hoisted_43 = { class: "truncate text-sm font-bold text-slate-950" }
const _hoisted_44 = { class: "mt-0.5 truncate text-xs text-slate-500" }
const _hoisted_45 = {
  key: 0,
  class: "mt-1 truncate text-[11px] font-medium text-slate-400"
}

import { computed, ref } from 'vue';
import { useSidebar } from "../hooks/useSidebar";
import { usePaymentNotifications } from "@/hooks/usePaymentNotifications";
import { useStore } from "vuex";
import { LOGOUT } from "@/store/auth.module";
import {
  FINANCE_ROLES,
  ROLE_DASHBOARD_TITLES,
  canAccess,
} from "@/utils/permissions";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const store = useStore();
const dropdownOpen = ref(false);
const { isOpen } = useSidebar();
const selectedRoleId = computed<string | null>(() => store.getters["appSelector/selectedRole"]?.id || null);
const canViewPaymentNotifications = computed(() => canAccess(FINANCE_ROLES, selectedRoleId.value));
const {
  isOpen: notificationOpen,
  isLoading: notificationLoading,
  errorMessage: notificationError,
  items: notifications,
  summary: notificationSummary,
  badgeLabel: notificationBadge,
  refresh: fetchNotifications,
  toggle: toggleNotifications,
  close: closeNotifications,
  isUnread: isNotificationUnread,
  iconClass: notificationIconClass,
} = usePaymentNotifications(canViewPaymentNotifications);

const currentUser = computed(() => store.getters.currentUser);
const userEmail = computed(() => currentUser.value?.email || "-");
const userUsername = computed(() =>
  currentUser.value?.preferredUsername ||
  currentUser.value?.preferred_username ||
  currentUser.value?.username ||
  "-"
);
const userDisplayName = computed(() =>
  currentUser.value?.name ||
  userUsername.value ||
  userEmail.value ||
  "Admin"
);
const showUsernameDetail = computed(() =>
  userUsername.value !== "-" && userUsername.value !== userDisplayName.value
);
const dashboardTitle = computed(() => (
  selectedRoleId.value ? ROLE_DASHBOARD_TITLES[selectedRoleId.value] || "Dashboard Admin" : "Dashboard Admin"
));

const logout = async () => {
  await store.dispatch(LOGOUT);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true)),
        class: "mr-2 shrink-0 rounded-lg p-1.5 text-gray-500 hover:bg-slate-100 focus:outline-none lg:hidden",
        "aria-label": "Buka menu"
      }, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("svg", {
          class: "w-6 h-6",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            d: "M4 6H20M4 12H20M4 18H11",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1)
      ]))]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(dashboardTitle.value), 1),
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-[11px] font-medium text-slate-500 mt-1 hidden sm:block uppercase tracking-wider" }, " Ikatan Orang Tua Mahasiswa ITB ", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (canViewPaymentNotifications.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(toggleNotifications) && _unref(toggleNotifications)(...args))),
                class: "relative mx-3 inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 transition hover:bg-slate-50 hover:text-[#003793] focus:outline-none focus:ring-2 focus:ring-blue-500/30",
                "aria-label": "Buka notifikasi"
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("svg", {
                  class: "h-5 w-5",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M15 17H20L18.5951 15.5951C18.2141 15.2141 18 14.6973 18 14.1585V11C18 8.38757 16.3304 6.16509 14 5.34142V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V5.34142C7.66962 6.16509 6 8.38757 6 11V14.1585C6 14.6973 5.78595 15.2141 5.40493 15.5951L4 17H9M15 17V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18V17M15 17H9",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)),
                (_unref(notificationBadge))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(notificationBadge)), 1))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(closeNotifications) && _unref(closeNotifications)(...args))),
                class: "fixed inset-0 z-10 h-full w-full"
              }, null, 512), [
                [_vShow, _unref(notificationOpen)]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", null, [
                    _createElementVNode("h2", { class: "text-sm font-bold text-slate-950" }, "Notifikasi Pembayaran"),
                    _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-500" }, " Donasi dan transaksi Merchandise via Midtrans. ")
                  ], -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-slate-500 transition hover:bg-slate-100 hover:text-[#003793] disabled:cursor-wait disabled:opacity-50",
                    disabled: _unref(notificationLoading),
                    "aria-label": "Muat ulang notifikasi",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_unref(fetchNotifications) && _unref(fetchNotifications)(...args)), ["stop"]))
                  }, [
                    (_openBlock(), _createElementBlock("svg", {
                      class: _normalizeClass(["h-4 w-4", { 'animate-spin': _unref(notificationLoading) }]),
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("path", {
                        d: "M20 11A8 8 0 0 0 5.9 5.9M4 5v5h5",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1),
                      _createElementVNode("path", {
                        d: "M4 13a8 8 0 0 0 14.1 5.1M20 19v-5h-5",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1)
                    ]))], 2))
                  ], 8, _hoisted_12)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_router_link, {
                    to: "/donasi",
                    class: "px-4 py-3 transition hover:bg-white",
                    onClick: _unref(closeNotifications)
                  }, {
                    default: _withCtx(() => [
                      _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-[11px] font-semibold text-slate-500" }, "Donasi Lunas", -1)),
                      _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(notificationSummary).donationCount), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_router_link, {
                    to: "/transactions",
                    class: "px-4 py-3 transition hover:bg-white",
                    onClick: _unref(closeNotifications)
                  }, {
                    default: _withCtx(() => [
                      _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-[11px] font-semibold text-slate-500" }, "Merchandise Lunas", -1)),
                      _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(notificationSummary).merchandiseCount), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                (_unref(notificationError))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(notificationError)), 1))
                  : _createCommentVNode("", true),
                (_unref(notificationLoading) && _unref(notifications).length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item) => {
                        return _createElementVNode("div", {
                          key: item,
                          class: "flex gap-3"
                        }, [...(_cache[13] || (_cache[13] = [
                          _createElementVNode("div", { class: "h-9 w-9 animate-pulse rounded-full bg-slate-100" }, null, -1),
                          _createElementVNode("div", { class: "flex-1 space-y-2" }, [
                            _createElementVNode("div", { class: "h-3 w-4/5 animate-pulse rounded bg-slate-100" }),
                            _createElementVNode("div", { class: "h-3 w-2/3 animate-pulse rounded bg-slate-100" })
                          ], -1)
                        ]))])
                      }), 64))
                    ]))
                  : (_unref(notifications).length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[14] || (_cache[14] = [
                        _createStaticVNode("<div class=\"mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-500\"><svg class=\"h-5 w-5\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 12l2 2 4-4M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div><p class=\"mt-3 text-sm font-semibold text-slate-900\">Belum ada pembayaran baru</p><p class=\"mt-1 text-xs text-slate-500\">Pembayaran Midtrans yang lunas akan muncul di sini.</p>", 3)
                      ]))]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications), (item) => {
                          return (_openBlock(), _createBlock(_component_router_link, {
                            key: item.id,
                            to: item.route,
                            class: "group flex gap-3 border-b border-slate-100 px-4 py-3 transition last:border-b-0 hover:bg-blue-50/50",
                            onClick: _unref(closeNotifications)
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full", _unref(notificationIconClass)(item.tone)])
                              }, [
                                (item.kind === 'donation-paid')
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_20, [...(_cache[15] || (_cache[15] = [
                                      _createElementVNode("path", {
                                        d: "M12 21s-7-4.35-9.2-8.6C1.2 9.3 3.1 6 6.5 6c1.9 0 3.3 1 4.1 2.2C11.4 7 12.8 6 14.7 6c3.4 0 5.3 3.3 3.7 6.4C16.2 16.65 12 21 12 21Z",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round"
                                      }, null, -1)
                                    ]))]))
                                  : (_openBlock(), _createElementBlock("svg", _hoisted_21, [...(_cache[16] || (_cache[16] = [
                                      _createElementVNode("path", {
                                        d: "M6 8h12l-1 12H7L6 8Z",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linejoin": "round"
                                      }, null, -1),
                                      _createElementVNode("path", {
                                        d: "M9 8a3 3 0 0 1 6 0",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round"
                                      }, null, -1)
                                    ]))]))
                              ], 2),
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("div", _hoisted_24, [
                                    (_unref(isNotificationUnread)(item))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("p", _hoisted_26, _toDisplayString(item.title), 1)
                                  ]),
                                  _createElementVNode("span", _hoisted_27, _toDisplayString(item.relativeTime), 1)
                                ]),
                                _createElementVNode("p", _hoisted_28, _toDisplayString(item.subject), 1),
                                _createElementVNode("p", _hoisted_29, _toDisplayString(item.description), 1),
                                _createElementVNode("div", _hoisted_30, [
                                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-semibold text-slate-600" }, "Midtrans", -1)),
                                  (item.amountLabel)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(item.amountLabel), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to", "onClick"]))
                        }), 128))
                      ])),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_router_link, {
                    to: "/dashboard-pembayaran",
                    class: "px-4 py-3 text-center text-xs font-bold text-[#003793] transition hover:bg-slate-50",
                    onClick: _unref(closeNotifications)
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createTextVNode(" Dashboard Pembayaran ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_router_link, {
                    to: "/transactions",
                    class: "px-4 py-3 text-center text-xs font-bold text-[#003793] transition hover:bg-slate-50",
                    onClick: _unref(closeNotifications)
                  }, {
                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                      _createTextVNode(" Transaksi Merchandise ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ], 512), [
                [_vShow, _unref(notificationOpen)]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("span", _hoisted_35, _toDisplayString(userDisplayName.value), 1),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (dropdownOpen.value = !dropdownOpen.value)),
            class: "relative z-10 block w-8 h-8 overflow-hidden rounded-full shadow focus:outline-none focus:ring-2 focus:ring-blue-500/30",
            "aria-label": "Buka menu akun"
          }, [
            _createElementVNode("img", {
              class: "object-cover w-full h-full",
              src: require('@/assets/image/logo.webp'),
              alt: "Your avatar"
            }, null, 8, _hoisted_36)
          ])
        ]),
        _withDirectives(_createElementVNode("div", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (dropdownOpen.value = false)),
          class: "fixed inset-0 z-10 w-full h-full"
        }, null, 512), [
          [_vShow, dropdownOpen.value]
        ]),
        _createVNode(_Transition, {
          "enter-active-class": "transition duration-150 ease-out transform",
          "enter-from-class": "scale-95 opacity-0",
          "enter-to-class": "scale-100 opacity-100",
          "leave-active-class": "transition duration-150 ease-in transform",
          "leave-from-class": "scale-100 opacity-100",
          "leave-to-class": "scale-95 opacity-0"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("img", {
                      class: "h-full w-full object-cover",
                      src: require('@/assets/image/logo.webp'),
                      alt: ""
                    }, null, 8, _hoisted_41)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("p", _hoisted_43, _toDisplayString(userDisplayName.value), 1),
                    _createElementVNode("p", _hoisted_44, _toDisplayString(userEmail.value), 1),
                    (showUsernameDetail.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_45, "@" + _toDisplayString(userUsername.value), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("button", {
                onClick: logout,
                class: "flex items-center gap-2 px-4 py-3 text-sm font-semibold text-red-600 hover:bg-red-50 w-full"
              }, [...(_cache[20] || (_cache[20] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-5 w-5",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                  })
                ], -1),
                _createTextVNode(" Log out", -1)
              ]))])
            ], 512), [
              [_vShow, dropdownOpen.value]
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})